import { ChainTab, ChainTabList, ChainTabPanel, ChainTabs } from "./ChainTabs.jsx";
import { SubMenu, SubMenuItem } from "../../common/components/SubMenu.jsx";

import { Localization } from "../../common/util/localization.jsx";
import MultiEpixSortimentList from "./MultiEpixSortimentList.jsx";
import PropTypes from "prop-types";
import React from "react";
import { createReselector } from "../../common/util/reselect.js";
import { iconTypes } from "../../common/components/Icon.jsx";
import { scssVariables } from "../../common/util/config.jsx";
import { withRouter } from "react-router-dom";

class MultiEpixSortimentCard extends React.PureComponent {
    constructor(props) {
        super(props);

        this.swallowOnClick = this.swallowOnClick.bind(this);
        this.onTabAllClicked = this.onTabAllClicked.bind(this);
        this.onTabNewClicked = this.onTabNewClicked.bind(this);
        this.calculateInternalPanelHeight = this.calculateInternalPanelHeight.bind(this);
        this.onExportCsv = this.onExportCsv.bind(this);

        this.groupProductsReselector = createReselector(chainProducts => {
            let group = [];
            const groups = [];

            for (const p of chainProducts) {
                if (group.length === 0) {
                    group.push(p.product);
                } else if (group[0].productId === p.product.productId) {
                    group.push(p.product);
                } else {
                    groups.push(group);
                    group.sort((a, b) => a.chainName - b.chainName);
                    group = [p.product];
                }
            }

            if (group.length > 0) {
                groups.push(group);
                group.sort((a, b) => a.chainName - b.chainName);
            }

            return groups;
        });
    }

    onTabAllClicked() {
        this.props.editMultiEpixFilter({
            onlyNews: false,
        });
    }

    onTabNewClicked() {
        this.props.editMultiEpixFilter({
            onlyNews: true,
        });
    }

    swallowOnClick(event) {
        event.stopPropagation();
        event.preventDefault();
    }

    onExportCsv() {

        const {
            multiEpixSortiment,
            exportCsv,
        } = this.props;

        exportCsv(multiEpixSortiment);
    }

    calculateInternalPanelHeight() {
        let tabPanelHeight = this.props.height;

        // Remove height of tab panel
        tabPanelHeight -= parseInt(scssVariables.menuHeightWithBorder);
        return tabPanelHeight;
    }

    render() {
        const {
            chains,
            clearEpixProductDetails,
            currentView,
            deviceType,
            height,
            loadMoreSearchResults,
            localization,
            setModal,
            multiEpixSortiment,
            updateChainProducts,
            width,
        } = this.props;
        const tabPanelHeight = this.calculateInternalPanelHeight();

        const groupedProducts = this.groupProductsReselector(multiEpixSortiment.allProducts);

        return (
            <div className={"card-default"} style={{ display: "flex", flexDirection: "column", height: `${height}px`, width: `${width}px` }}>
                <ChainTabs startTabId={currentView}>
                    <ChainTabList>
                        <ChainTab id="allProducts" label={localization.text("chain", "epixSortiment", "allProducts", { count: 1234 })} onClick={this.onTabAllClicked} />
                        <ChainTab id="newProducts" label={localization.text("chain", "epixSortiment", "newProducts", { count: 12 })} onClick={this.onTabNewClicked} />
                        <SubMenu border={true} style={{flex:"0 0 61px"}}>
                            <SubMenuItem side="right" roundCornerTopRight={true} onClick={this.onExportCsv} isDroppedDown={false} iconType={iconTypes.csvFile} />
                        </SubMenu>
                    </ChainTabList>
                    <ChainTabPanel>
                        <MultiEpixSortimentList
                            chains={chains}
                            clearEpixProductDetails={clearEpixProductDetails}
                            deviceType={deviceType}
                            height={tabPanelHeight}
                            isLoading={multiEpixSortiment.isLoading}
                            list={groupedProducts}
                            loadMoreProducts={loadMoreSearchResults}
                            localization={localization}
                            setModal={setModal}
                            updateChainProducts={updateChainProducts}
                        />
                    </ChainTabPanel>
                    <ChainTabPanel>
                        <MultiEpixSortimentList
                            chains={chains}
                            clearEpixProductDetails={clearEpixProductDetails}
                            deviceType={deviceType}
                            height={tabPanelHeight}
                            isLoading={multiEpixSortiment.isLoading}
                            list={groupedProducts}
                            loadMoreProducts={loadMoreSearchResults}
                            localization={localization}
                            setModal={setModal}
                            updateChainProducts={updateChainProducts}
                        />
                    </ChainTabPanel>
                </ChainTabs>
            </div>
        );
    }
}

MultiEpixSortimentCard.propTypes = {
    chains: PropTypes.object.isRequired,
    clearEpixProductDetails: PropTypes.func.isRequired,
    currentView: PropTypes.string,
    deviceType: PropTypes.string.isRequired,
    editMultiEpixFilter: PropTypes.func.isRequired,
    height: PropTypes.number.isRequired,
    history: PropTypes.object.isRequired,
    loadMoreSearchResults: PropTypes.func.isRequired,
    localization: Localization.propTypes.isRequired,
    location: PropTypes.object.isRequired,
    setModal: PropTypes.func.isRequired,
    multiEpixSortiment: PropTypes.object.isRequired,
    updateChainProducts: PropTypes.func.isRequired,
    width: PropTypes.number.isRequired,
    exportCsv : PropTypes.func.isRequired,
};

MultiEpixSortimentCard.defaultProps = {
    currentView: "all",
};
export default withRouter(MultiEpixSortimentCard);
